// Microsoft Clarity (official tag). Loads once, only after analytics consent, only where enabled.
const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

export function clarityEnabled() {
  if (!CLARITY_ID || typeof window === "undefined") return false;
  const preview = window.location.hostname.endsWith(".preview.emergentagent.com");
  return preview || process.env.REACT_APP_CLARITY_PRODUCTION_APPROVED === "true";
}

export function loadClarity() {
  if (!clarityEnabled()) return;
  if (!window.clarity) {
    window.clarity = function clarity() { (window.clarity.q = window.clarity.q || []).push(arguments); };
  }
  if (!document.getElementById("cy-clarity")) {
    const s = document.createElement("script");
    s.id = "cy-clarity";
    s.async = true;
    s.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
    document.head.appendChild(s);
  }
  window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "granted" });
}

export function revokeClarity() {
  if (!window.clarity) return;
  // Consent first (clears cookies), then stop so no further session data is collected on this page.
  window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "denied" });
  window.clarity("consent", false);
  window.clarity("stop");
}

// Event names only; never personal data.
export function clarityEvent(name) {
  if (clarityEnabled() && window.clarity && document.getElementById("cy-clarity")) window.clarity("event", name);
}

// Private areas (dashboards, account pages) are fully masked in recordings.
export function setClarityMask(isPrivate) {
  if (isPrivate) document.body?.setAttribute("data-clarity-mask", "true");
  else document.body?.removeAttribute("data-clarity-mask");
}
